import { useSelector } from 'react-redux';
import { getSellingComputed } from '../../selector';
import { IStore } from 'store/interface';
import { ISalesRecord } from '../../interfaces';

export const useSellingComputed = () => ({
  computed: useSelector<IStore, ISalesRecord['selling']['computed']>(getSellingComputed),
});
